/**
 * This provides an interface to push data into common object for tracking
 */

// trackData would have different containers
// for default/global purpose, we would use default.
// We can also use custom containers for holding data that would be used for soecific track/page/identify calls

const trackData = {
    default: {},
};

export default {
    set(obj, containerParam) {
        // var obj = {key: "somekey", value: "somevalue"}
        const container = containerParam || 'default';
        const key = obj.key.toLowerCase();

        if (typeof trackData[container] != 'object') {
            trackData[container] = {};
        }
        trackData[container][key] = obj.value;
    },
    setMany(arrObj, containerParam) {
        const container = containerParam || 'default';
        if (typeof arrObj != 'object') return;

        for (let i = 0; i < arrObj.length; ++i) {
            this.set(arrObj[i], container);
        }
    },
    get(containerParam) {
        const container = containerParam || 'default';
        return trackData[container];
    },
};
